/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Thirdsubjectgraduationcoursetype4Inputs */

const de__field_thirdsubjectgraduationcoursetype4 = /** @type {(inputs: _Field_Thirdsubjectgraduationcoursetype4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drittfach Kursart`)
};

/**

* @param {_Field_Thirdsubjectgraduationcoursetype4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_thirdsubjectgraduationcoursetype4 = /** @type {((inputs?: _Field_Thirdsubjectgraduationcoursetype4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Thirdsubjectgraduationcoursetype4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_thirdsubjectgraduationcoursetype4(inputs)
});
export { _field_thirdsubjectgraduationcoursetype4 as "_field_thirdSubjectGraduationCourseType" }